import { render, staticRenderFns } from "./FBChat.vue?vue&type=template&id=2094f49c&scoped=true&"
import script from "./FBChat.vue?vue&type=script&lang=js&"
export * from "./FBChat.vue?vue&type=script&lang=js&"
import style0 from "./FBChat.vue?vue&type=style&index=0&id=2094f49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094f49c",
  null
  
)

export default component.exports